import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
import {Cartesian2, Cartesian3, Color} from "cesium";
/**
 * 设备数据图层
 */
class DeviceDataLayer extends BaseLayer{

    constructor(options={}){
        options.layerName=options.layerName||CONSTANTS.LAYER.DEVICEDATA;//图层名
        super(options);
        this.style=options.style||{};//样式
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj,index) =>{
            let item={...obj.attributes};
            item.layerName=self.layerName;
            let content="";
            item.deviceDataArr&&item.deviceDataArr.map((data,index)=>{
                if(index==0){
                    content+=data.channelName+": "+data.value+" "+data.physical;
                }else if(index<3){
                    content+="\n"+data.channelName+": "+data.value+" "+data.physical;
                }
            });
            let labelEntity = new Cesium.Entity({
              id:'LABEL'+index,
              name:item.name,
              attributes:item,
              position : Cesium.Cartesian3.fromDegrees(item.longitude, item.latitude,CONSTANTS.ALTITUDE),//高度单位：米
              //字体标签样式
              label : {
                text : content,
                color :Color.fromCssColorString('#fff'),
                font:'normal 32px MicroSoft YaHei',
                showBackground : true,
                scale : 0.4,
                distanceDisplayCondition : new Cesium.DistanceDisplayCondition(0.0, 1000.0),
                disableDepthTestDistance : 10000.0,
                pixelOffset:new Cartesian2(-10, -10),
                eyeOffset:new Cartesian3(0,0,-100),
              }
            });
            self.dataSource.entities.add(labelEntity);
        });
    }
}
export default DeviceDataLayer;
